import React, { useEffect, useRef } from "react";
import moment from "moment";
import { RiSendPlaneFill } from "react-icons/ri";
import Form from "react-bootstrap/Form";
import UserProfileNoImg from "@/../../public/images/no-image.jpg";

const ChatWindow = ({
  chatHistory,
  user,
  newMessage,
  setNewMessage,
  sendMessage,
  adminDetails,
}: any) => {
  const chatContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Scroll to the bottom whenever chatHistory changes
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory]);
  const showDate = (currentChat: any, prevChat: any) => {
    const currentDate = moment(currentChat.createdAt);
    const prevDate = prevChat ? moment(prevChat.createdAt) : null;

    if (prevDate && currentDate.isSame(prevDate, "day")) {
      return false;
    }

    if (currentDate.isSame(moment(), "day")) {
      return "Today";
    } else if (currentDate.isSame(moment().subtract(1, "day"), "day")) {
      return "Yesterday";
    } else {
      return currentDate.format("DD MMMM YYYY");
    }
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      sendMessage();
    }
  };

  return (
    <div className="col-lg-12">
      <div className="chats-holder">
        <div className="chats-holder-chat" ref={chatContainerRef}>
          <div className="profile-admin-sec">
            <span className="profileadminimage">
              <img
                src={
                  adminDetails?.profileimageurl
                    ? adminDetails?.profileimageurl
                    : UserProfileNoImg
                }
                alt="profile"
              />
            </span>
            <h2>
              {adminDetails?.firstName} {adminDetails?.lastName}
            </h2>
          </div>
          {chatHistory &&
            chatHistory.length > 0 &&
            chatHistory.map((message: any, index: number) => {
              const isCurrentUser = message.sender.id === user?._id;

              return (
                <div className="chats" key={index}>
                  {index === 0 || showDate(message, chatHistory[index - 1]) ? (
                    <div className="separetor mt-3 mb-3">
                      <p>{showDate(message, chatHistory[index - 1])}</p>
                    </div>
                  ) : (
                    ""
                  )}
                  <div
                    className={`chats__${isCurrentUser ? "right" : "left"}`}
                    key={index}
                  >
                    <div className="people">
                      {!isCurrentUser && (
                        <div className="profilemsm">
                          <img
                            src={
                              message?.sender?.profileimageurl
                                ? message?.sender?.profileimageurl
                                : UserProfileNoImg
                            }
                            alt="profile"
                          />
                        </div>
                      )}
                    </div>
                    <div className="message">
                      <div className="message__date">
                        {!isCurrentUser && (
                          <p>
                            {message?.sender?.firstName}{" "}
                            {message?.sender?.lastName}, 
                          </p>
                        )}
                        <span> 
                          {message?.createdAt
                            ? moment(message?.createdAt).format("HH:mm")
                            : ""}
                        </span>
                      </div>
                      <div className="message__txt">
                        <p>{message?.content}</p>
                      </div>
                    </div>
                  </div>

                  {/* <div className="chats__right">
                                  <div className="message">
                                    <div className="message__date">
                                      <p>
                                        {" "}
                                        <span>17:53</span>
                                      </p>
                                    </div>
                                    <div className="message__txt">
                                      <p>
                                        Hi Adam, thank you for reaching out!
                                        Yes, I'd be happy to chat about the role
                                        and how my experience aligns with it.
                                      </p>
                                    </div>
                                  </div>
                                </div> */}
                </div>
              );
            })}
        </div>

        <div className="input-container">
          <Form.Control
            type="text"
            placeholder="Type a message"
            id="messageInput"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <button type="submit" onClick={sendMessage}>
            <RiSendPlaneFill />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatWindow;
